import axios from 'axios';
import { ClubSwingAverage, ClubSwingData, SwingImportResult, UpsertClubInput } from '../types';
import { attachAuthInterceptor } from './authToken';

const BASE_URL = process.env.REACT_APP_CLUBHOUSE_API_URL || 'http://localhost:5000';

const apiClient = axios.create({
  baseURL: `${BASE_URL}/api`,
});
attachAuthInterceptor(apiClient);

export const swingApi = {
  import: async (file: File, user: string, replace = false): Promise<SwingImportResult> => {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await apiClient.post<SwingImportResult>(
      '/swings/import',
      formData,
      { params: { replace, user }, headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return data;
  },

  getAll: async (user: string, clubType?: string): Promise<ClubSwingData[]> => {
    const { data } = await apiClient.get<ClubSwingData[]>('/swings', {
      params: { user, clubType: clubType || undefined },
    });
    return data;
  },

  getAverages: async (user: string): Promise<ClubSwingAverage[]> => {
    const { data } = await apiClient.get<ClubSwingAverage[]>('/swings/averages', {
      params: { user },
    });
    return data;
  },

  upsertClub: async (club: UpsertClubInput, user: string): Promise<ClubSwingAverage> => {
    const { data } = await apiClient.put<ClubSwingAverage>('/swings/club', club, {
      params: { user },
    });
    return data;
  },

  deleteClub: async (user: string, clubType: string, clubBrand?: string, clubModel?: string): Promise<void> => {
    await apiClient.delete('/swings/club', {
      params: { user, clubType, clubBrand: clubBrand || undefined, clubModel: clubModel || undefined },
    });
  },

  clear: async (user: string): Promise<void> => {
    await apiClient.delete('/swings', { params: { user } });
  },
};
